import React, { Fragment, useState, useEffect } from "react";
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, Table } from 'reactstrap';
import DatePicker, { registerLocale } from "react-datepicker";
import { useTranslation } from 'react-i18next';
import es from 'date-fns/locale/es';
import TimetableIcon from 'mdi-react/TimetableIcon';
import renderSelectField from '../../../../shared/components/form/Select';
import { Field, reduxForm } from 'redux-form';
import moment from 'moment';
import Modal from '../../../../shared/components/Modal';
import ThirdsApi from '../../api/thirds_api';

registerLocale('es', es)


const CriterialSeachStudio = ({ history, location }) => {
    const { t } = useTranslation('common');

    const [allSponsors, setAllSponsors] = React.useState([]);
    const [optionsSponsors, setOptionsSponsors] = React.useState([]);
    const [sponsor, setSponsor] = React.useState(null);
    const [acronym, setAcronym] = React.useState(null);
    const [date, setDate] = React.useState(null);
    const [dateFormat, setDateFormat] = React.useState(null);
    const [state, setState] = React.useState(null);
    const [list, setList] = React.useState([]);

    const [showModal, setShowModal] = React.useState(false);
    const [messageModal, setMessageModal] = React.useState(null);
    const [colorModal, setColorModal] = React.useState("success");



    const handleFocus = (e) => {
        e.preventDefault();
        let _input = e.currentTarget;
        let _parent = _input.parentNode.parentNode;
        let _label = _parent.firstChild

        if (_label.className === "form__form-group-label") {
            _label.className += " focusin"
        } else {
            if (_input.value.length === 0) {
                _label.className = "form__form-group-label";
            }
        }
    }

    const handleFocusPicker = (e) => {
        e.preventDefault();
        let _input = e.currentTarget;
        let _parent = _input.parentNode.parentNode.parentNode;
        let _label = _parent.firstChild

        if (_label.className === "form__form-group-label") {
            _label.className += " focusin"
        } else {
            if (_input.value.length === 0) {
                _label.className = "form__form-group-label";
            }
        }
    }

    const handleFocusSelect = (e) => {
        e.preventDefault();
        let _select = e.currentTarget;
        let _parent = _select.parentNode.parentNode;
        let _label = _parent.firstChild

        if (_label.className === "form__form-group-label") {
            _label.className += " focusin"
        } else {
            if (_select.selectedIndex === 0) {
                _label.className = "form__form-group-label";
            }
        }
    }

    const validateSponsor = () => {
        let _acronym = acronym == null || acronym.length < 1;

        if (sponsor == null) {
            return true;
        } else {
            if (sponsor.length >= 1 && _acronym) {
                openModal(false, t('msg.sponsor_and_acronym_require'));
                return false;
            } else {
                return true;
            }
        }
    }

    const validateCriteria = () => {
        let _sponsor = sponsor == null || sponsor.length < 1;
        let _acronym = acronym == null || acronym.length < 1;
        let _date = date == null || date.length < 1;
        let _state = state == null || state === 0;

        if (_sponsor && _acronym && _date && _state) {
            openModal(false, "Ingresa uno de los criterios para realizar la búsqueda.");
            return false;
        } else {
            return true;
        }
    }

    const validate = async () => {
        if (validateCriteria()) {
            if (validateSponsor()) {
                sendRequest();
            }
        }
    }

    const sendRequest = async () => {

    }

    const AllRow = () => {
        return (
            <Row>
                <Col >
                </Col>
            </Row>
        );
    }

    const listSponsors = async () => {
        let sponsors = await ThirdsApi.listSponsors();
        console.log(sponsors);
        if (sponsors != null) {
            setAllSponsors(sponsors);
            SponsorList(sponsors);
        }
        else {
            setAllSponsors([]);
        }
    }

    const SponsorList = (data) => {
        let _rows = [];
        data.forEach(sponsor => {
            _rows.push({ value: sponsor.id_tercero, label: sponsor.nombre });
        });
        setOptionsSponsors(_rows);
    }

    const changeOptionSponsor = (opt) => {
        setSponsor(opt.value);
    }

    const changeOptionState = (opt) => {
        setState(opt.value);
    }

    const openModal = (success, message) => {
        if (success == true) {
            setColorModal("success");
        }
        else {
            setColorModal("danger");
        }
        setShowModal(true);
        setMessageModal(message);
    }

    useEffect(() => {
        listSponsors();
    }, []);

    return (
        <Card>
            <CardBody>
                <div className="card__title">
                    <h5 className="bold-text">Criterios de Busqueda</h5>
                    <h5 className="subhead">Ingresa uno de los criterios para realizar la búsqueda.</h5>
                </div>



                <Row>
                    <form className="form form_vertical">
                        <Col md={3}>

                            <div className="form__form-group">
                                <span className="form__form-group-label">Patrocinador</span>
                                <div className="form__form-group-field">

                                    <Field
                                        name="select_patrocinador"
                                        component={renderSelectField}
                                        type="text"
                                        options={optionsSponsors}
                                        value={sponsor}
                                        onChange={changeOptionSponsor}
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div style={{ left: '5%' }} className="form__form-group">
                                <span className="form__form-group-label">Acronimo</span>
                                <div className="form__form-group-field">
                                    <input type="text" onBlur={handleFocus} onFocus={handleFocus}
                                        onChange={({ target: { value } }) => setAcronym(value)} />
                                </div>
                            </div>
                        </Col>

                        <Col md={3}>
                            <div style={{ left: '10%' }} className="form__form-group">
                                <span className="form__form-group-label">Fecha</span>
                                <div className="form__form-group-field">
                                    <DatePicker
                                        //locale="es"
                                        isClearable
                                        selected={date}
                                        onChange={(date_calendar) => {
                                            if (date_calendar != null) {
                                                let fecha_seleccionada = moment(date_calendar).format('YYYY/MM/DD');
                                                setDate(date_calendar);
                                                setDateFormat(fecha_seleccionada);
                                            }
                                            else {
                                                setDate(null);
                                                setDateFormat(null);
                                            }
                                        }}
                                        dateFormat="yyyy/MM/dd"
                                        dropDownMode="select"
                                        popperPlacement="center"
                                        onBlur={handleFocusPicker} onFocus={handleFocusPicker}
                                    />

                                    <div className="form__form-group-icon">
                                        <TimetableIcon />
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="form__form-group">
                                <span className="form__form-group-label">Estado</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="select_estado"
                                        component={renderSelectField}
                                        type="text"
                                        options={
                                            [
                                                /*
                                                { value: 1, label: "En Proceso" },
                                                { value: 2, label: "Aceptada" },
                                                { value: 3, label: "No Aceptada" },
                                                { value: 4, label: "Finalizada" }
                                                */
                                            ]
                                        }
                                        onChange={changeOptionState}
                                    />
                                </div>
                            </div>
                        </Col>

                        <Col md={12}>
                            <Button color="primary" type="button"
                                onClick={() => validate()}>
                                Buscar
                            </Button>
                        </Col>
                    </form>
                </Row>


                {list.length > 0 && <AllRow />}

                <Modal
                    color={colorModal}
                    title={messageModal}
                    modal={showModal}
                    onOk={() => setShowModal(false)}
                    toggle={() => setShowModal(false)}
                />

            </CardBody>
        </Card>
    );
}
export default reduxForm({
    form: 'horizontal_form_clinical_studio', // a unique identifier for this form
})(CriterialSeachStudio);